// covered-by: frontends/carrie/src/ask-v2/review/__tests__/AskV2ReviewWorkspace.test.tsx
import { createContext, useContext } from "react";

type AskV2ReviewComposerContextValue = {
  onRemoveCommentContext: (id: string) => void;
};

const AskV2ReviewComposerContext =
  createContext<AskV2ReviewComposerContextValue | null>(null);

export function AskV2ReviewComposerProvider({
  onRemoveCommentContext,
  children,
}: {
  onRemoveCommentContext: (id: string) => void;
  children: React.ReactNode;
}) {
  return (
    <AskV2ReviewComposerContext.Provider value={{ onRemoveCommentContext }}>
      {children}
    </AskV2ReviewComposerContext.Provider>
  );
}

export function useAskV2ReviewComposerContext() {
  return useContext(AskV2ReviewComposerContext);
}
